(() => {
  let limit = 10;
  function defer(method) {
    if (limit > 0) {
      limit -= 1;
    }

    if (window.jQuery) {
      method();
    } else {
      setTimeout(function() { defer(method) }, 500);
    }
  }

  const initialize = () => {
    const { locales, product } = window.storeAvailabilityData;

    // Trigger
    const $inStoreBtnTrigger = $('.js-product-store-availability-trigger');
    // Search
    const $inStoreSearchForm = $('.js-product-modal-search');
    const $inStoreCloseModal = $('.js-product-modal-close');
    const $inStoreOverlay = $('.js-product-modal-overlay');
    const $inStoreInput = $('.js-product-modal-search-input');
    const $inStoreModal = $('.js-product-availability-modal');
    const $inStoreSearchMyLocation = $('.js-search-current-location');
    const $inStoreProductInfoDropdown = $('.js-product-info');
    const $body = $('body');
    // Store listing
    const $inStoreListingContainer = $('.js-product-modal-stores-container');
    const $inStoreListingResult = $('.js-product-modal-stores-result');
    const $inStoreListing = $('.js-product-modal-stores-listing');
    const $inStoreErrMobile = $('.js-product-modal-error-mobile');
    const googleMapApiKey = 'AIzaSyDzjW5LAzfvX4i-gOI0zxMOZRvb-yYk47Q';
    let $inStoreHoursDropdownTrigger;
    let $inStoreGetDirection;
  
    let searchMethod = {};
    let currentVariant;
    let previousVariant;
    let productSku;
  
    const getAddress = function(event) {
      event.preventDefault();
      const searchTerm = $inStoreInput.val().split(' ').join('+');
      const url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + searchTerm + '&key=' + googleMapApiKey;
  
      const wrongFormatErrMsg = {
        err1: locales.errors.wrong_address_p1,
        err2: locales.errors.wrong_address_p2
      }
  
      const emptyFieldErrMsg = {
        err1: locales.errors.empty_address_p1,
        err2: locales.errors.empty_address_p2
      }
  
      $.post(url, function(geoResult) {
  
        if (geoResult.status === "ZERO_RESULTS") {
          return errorMessage(wrongFormatErrMsg, searchTerm);
        }
  
        const geoLat = geoResult.results[0].geometry.location.lat;
        const geoLng = geoResult.results[0].geometry.location.lng;
  
        searchMethod = {
          searchTerm: searchTerm,
          currentLocation: false
        }
  
        getStores(geoLat, geoLng, searchTerm);
  
      }).fail(function() {
        return errorMessage(emptyFieldErrMsg, null)
      });
    };
  
    const getStores = async function(latitude, longitude, searchTerm) {
      const errorMsg = {
        err1: locales.errors.no_result_found_p1,
        err2: locales.errors.no_result_found_p2
      }
      const formData = {
        latitude: latitude,
        longitude: longitude,
        skus: [productSku],
        radius: 25
      };
      const url = '/apps/stores-api-1/v1/stores';
  
      $inStoreListingContainer.removeClass('is-hidden').addClass('is-loading');

      $.ajax({
        url: url,
        type: 'get',
        data: formData,
        success: function(response) {
          const stores = response.stores;
  
          if (!stores.length) {
            $inStoreListingContainer.removeClass('is-loading');
            return errorMessage(errorMsg, searchTerm)
          }
  
          const storeHasInventory = stores.reduce((available, store) => {
            return Boolean(available || store.variants);
          }, false);
  
          $inStoreListingResult.html('');
          $inStoreErrMobile.html('');
  
          if (storeHasInventory) {
            buildStoreListing(stores, searchTerm);
          } else {
            $inStoreListingContainer.removeClass('is-loading');
            return errorMessage(errorMsg, searchTerm);
          }
        },
        error: function() {
          $inStoreListingContainer.removeClass('is-loading');
          return errorMessage(errorMsg, searchTerm)
        },
      });
    };
  
    const errorMessage = function(errorMsg, searchTerm) {
  
      let error;
  
      if (searchTerm) {
        error = '<h4 class="ProductModal__Stores-Result-Header ProductText Error">' + errorMsg.err1 + ' "' + searchTerm + '" ' + errorMsg.err2 + '</h4>';
      } else {
        error = '<h4 class="ProductModal__Stores-Result-Header ProductText Error">' + errorMsg.err1 + errorMsg.err2 + '</h4>';
      }
  
      $inStoreListingResult.html(error);
      $inStoreErrMobile.html(error);
      $inStoreErrMobile.removeClass('is-hidden');
      $inStoreListing.html('');
  
      setTimeout(function() {
        $inStoreListingContainer.removeClass('is-hidden');
      }, 300);
  
      //Enable this if you want to have Error messages fade out over time
      /*
      setTimeout(function() {
        $inStoreListingResult.html('');
        $inStoreErrMobile.html('');
      }, 4000);
      */
    };
  
    const buildStoreListing = function(stores, search) {
      const days = ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'];
      const inventoryWarningAmt = $('.ProductSearchAvailability').data('inventory-warning-amt');
      const searchResult = `
          <h4 class="ProductModal__Stores-Result-Header ProductText Small">
            ${locales.result_1} "${search}" ${locales.result_2}
          </h4>`;
  
      const listing = stores
        .filter(store => store.variants.quantity > 0)
        .map(store => {
          const hasStoreAvailability = Boolean(store.variants.quantity > 0);
          const storeAddress = [
              store.address.address_1,
              store.address.address_2,
              store.address.city,
              store.address.postal_code,
              store.address.country
            ].join(',');
          let warningMessage = '<p class="ProductModal__Stores-Result-Warning ProductText Small">' + locales.stock_variation + '</p>';
  
          const warning = Boolean(store.variants && store.variants.quantity >= inventoryWarningAmt);
          const availabilityClass = warning ? '' : ' is-red';
          const availabilityText = warning ?
            locales.available : (
              store.variants && store.variants.quantity < inventoryWarningAmt ?
                locales.limited_stock :
                locales.no_stock
            );
  
          const storeAvailabilityMessage = '<p class="ProductModal__Store-Availability ProductText Small' + availabilityClass + '">' + availabilityText + '</p>';
  
          return `
            <div class="ProductModal__Store" data-address="${storeAddress}">
              <div class="ProductModal__Store--left">
                <h3 class="ProductModal__Store-Title ProductHeader Medium">${store.address.name}</h3>
                <p class="ProductModal__Store-Address">
                  ${store.address.address_1}, ${store.address.address_2}<br />
                  ${store.address.province}, ${store.address.city}, ${store.address.postal_code}
                </p>
              </div>
              <div class="ProductModal__Store--right">
                ${hasStoreAvailability ? storeAvailabilityMessage : warningMessage = ''}
                <a class="ProductModal__Store-Phone" href=tel:${store.phone}>tel: ${store.phone}</a>
                <div class="ProductModal__Directions">
                  <a class="ProductModal__Directions-Link js-get-direction">
                    ${locales.direction}
                    <span>(${store.distance}km)</span>
                  </a>
                </div>
              </div>
              <div class="ProductModal__Store-Hours js-product-modal-hours-dropdown-trigger">
                <span class="ProductModal__Store-Hours-Title">
                  ${locales.store_hours}
                </span>
                <ul class="ProductModal__Store-Hours-Body is-hidden js-product-modal-hours-dropdown">
                  ${
                    days.map((day, i) => {
                      let dayIndex = (i + 1) % 7;
                      return `
                        <li class="ProductModal__Store-Hours-Item">
                          <span class="Store-Hours-Item__Day">
                            ${locales.hours[day]}:
                          </span>
                          ${store.open_hours[dayIndex].open_time} - ${store.open_hours[dayIndex].close_time}
                        </li>
                      `
                    }).join('')
                  }
                </ul>
              </div>
            </div>
          `;
        });
  
      $inStoreListingResult.html(searchResult);
      $inStoreListing.html(listing);
  
      $inStoreGetDirection = $('.js-get-direction');
      $inStoreHoursDropdownTrigger = $('.js-product-modal-hours-dropdown-trigger');
      $inStoreHoursDropdown = $('.js-product-modal-hours-dropdown');
      $inStoreHoursDropdownTrigger.on('click', toggleDropdown);
      $inStoreGetDirection.on('click', function(e) {
        const store = this.closest('[data-address]');
        getDirection(e, store.dataset.address);
      });
  
      setTimeout(function() {
        $inStoreListingContainer.removeClass('is-loading');
      }, 300)
  
    };
  
    const clearStore = function() {
      $inStoreListingResult.html("");
      $inStoreListing.html("");
    };
  
    const closeModal = function() {
      $inStoreModal.removeClass('is-visible');
      $inStoreOverlay.removeClass('is-visible');
      $body.removeClass('noscroll');
    };
  
    // Ensure modal and overlay are direct children of <body> to avoid
    // stacking context issues from transformed/positioned ancestors
    const ensureInBody = function() {
      if (!$inStoreModal.parent().is('body')) {
        $inStoreModal.appendTo('body');
      }
      if (!$inStoreOverlay.parent().is('body')) {
        $inStoreOverlay.appendTo('body');
      }
    };

    const openModal = function() {
      ensureInBody();
      $inStoreModal.addClass('is-visible');
      $inStoreOverlay.addClass('is-visible');
      $body.addClass('noscroll');
    };
  
    const toggleDropdown = function(event) {
      const $productInfoContent = $('.js-product-info-content');
      const isProductInfo = $(event.target).hasClass('js-product-info');
      const isStoreHours = $(event.target).parent().hasClass('js-product-modal-hours-dropdown-trigger');
  
      if (isStoreHours) {
        $(event.target).toggleClass('is-open');
        $(event.target)
          .closest('.ProductModal__Store-Hours')
          .find('.js-product-modal-hours-dropdown')
          .toggleClass('is-hidden')
  
      } else if (isProductInfo) {
        $(event.target).find('.ProductModal__Trigger-Container').toggleClass('is-open');
        $(event.target).find('span').toggleClass('is-hidden');
        $productInfoContent.toggleClass('is-hidden');
      }
    };
  
    // TODO: Refactor to CSS-only solution
    const responsive = function() {
      if ($(window).width() > 640) {
        $('.ProductModal__Stores').append($inStoreListingContainer)
      } else {
        $inStoreListingContainer.insertAfter('.ProductModal__Variants');
      }
    };
  
    const getCurrentLocation = function() {
      if (!navigator.geolocation) {
        return console.warn('This browser does not support Geolocation');
      }
  
      $inStoreListingContainer.removeClass('is-hidden');
  
      let startPos;
      const error = {
        err1: locales.errors.current_location_p1,
        err2: locales.errors.current_location_p2
      }
  
      const errorNoSupport = {
        err1: locales.errors.no_support_p1,
        err2: locales.errors.no_support_p2
      }
  
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
          startPos = position;
          const latitude = startPos.coords.latitude;
          const longitude = startPos.coords.longitude;
  
          if (latitude && longitude) {
            searchMethod = {
              searchTerm: false,
              currentLocation: {
                longitude: longitude,
                latitude: latitude
              }
            }
            getStores(latitude, longitude, locales.current_location);
          }
        }, function() {
          errorMessage(error, null)
        });
      } else {
        errorMessage(errorNoSupport, null)
      }
    };
  
    const getDirection = function(e, storeLocation) {
      e.preventDefault();
  
      let searchFormat;
      if (!searchMethod.searchTerm) searchFormat = searchMethod.currentLocation.latitude + ',' + searchMethod.currentLocation.longitude;
      else if (!searchMethod.currentLocation) searchFormat = searchMethod.searchTerm
  
      const url = 'https://www.google.com/maps/dir/' + searchFormat + '/' + storeLocation;
  
      window.open(url);
    };

    const images = document.querySelectorAll('.js-product-modal-image');
    const updateSelectedVariant = function(id) {
      const variant = product.variants.find(variant => variant.id == id);

      if (!variant) {
        return false;
      }

      // Prestige requires the protocol to be included in the src
      if (variant.featured_media?.preview_image.src.indexOf('//') === 0) {
        variant.featured_media.preview_image.src = `${window.location.protocol}${variant.featured_media?.preview_image.src}`;
      }

      previousVariant = currentVariant || variant;
      currentVariant = variant;

      const image = variant.featured_image?.src;
      if (image) {
        const sizedImage = `${image}${image.includes('?') ? '&' : '?'}width=300`;
        images.forEach(el => {
          el.removeAttribute('srcset');
          el.src = sizedImage;
        });
      }

      if (variant.sku && variant.sku !== productSku) {
        productSku = variant.sku;
      }

      clearStore();
    };

    const syncVariantIDs = function () {
      const modalVariantID = document.querySelector('.js-product-availability-modal input[name="id"]');
      const modalForm = modalVariantID.closest('form');
      const formVariantID = document.querySelector('[data-block-type="buy-buttons"] input[name="id"]');
      const form = formVariantID.closest('form');

      updateSelectedVariant(modalVariantID.value);

      modalVariantID?.addEventListener('change', () => {
        if (formVariantID.value !== modalVariantID.value) {
          updateSelectedVariant(modalVariantID.value);
          formVariantID.value = modalVariantID.value;
          formVariantID.dispatchEvent(new Event('change'));
          form.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: currentVariant, product, previousVariant }}));
        }
      });

      formVariantID?.addEventListener('change', () => {
        if (formVariantID.value !== modalVariantID.value) {
          updateSelectedVariant(formVariantID.value);
          modalVariantID.value = formVariantID.value;
          modalVariantID.dispatchEvent(new Event('change'));
          modalForm.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: currentVariant, product, previousVariant }}));
        } 
      });
    };
  
    syncVariantIDs();
    responsive();
    $inStoreProductInfoDropdown.on('click', toggleDropdown)
    $inStoreSearchMyLocation.on('click', getCurrentLocation)
    $inStoreBtnTrigger.on('click', openModal);
    $inStoreCloseModal.on('click', closeModal);
    $inStoreOverlay.on('click', closeModal);
    $inStoreSearchForm.on('submit', getAddress);
    $(window).on('resize', responsive);
  };

  defer(initialize);
})();